import TableAHSF from "../../../../Components/TableAHSF";
import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { decryptToken } from "../../../../Services/Encryption/EncryptionParams";
import "./style.css";
import PopupAHSF from "../../../../Components/PopupAHSF";
import ImplementationStagesAdd from "./ImplementationStagesAdd";
import {
  DeleteImplementationStage,
  GetLengthImplementationStage,
} from "../../../../Redux/Reducers/Submitter/ImplementationStages";
import { setRefreshTable } from "../../../../Redux/Reducers/Shared/VariousVariables";

const ImplementationStages = (props) => {
  const [implementationStagesId,setImplementationStagesId]=useState(null)
    const [PopupComponentEditStatus, setPopupComponentEditStatus] =
    useState(false);
  const AppGuid = useParams();
  const stageLodingAdd = useSelector(
    (state) => state.ImplementationStageReducers.AddImplementationStage
  );
  const stageLodingDelete = useSelector(
    (state) => state.ImplementationStageReducers.DeleteImplementationStage
  );
  const ImplementationStageLength = useSelector(
    (state) => state.ImplementationStageReducers.ImplementationStageLength
  );
  const EditImplementationStageLength = useSelector(
    (state) => state.ImplementationStageReducers.ImplementationStageEdit
  );
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
      // ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformationReducer.ApplicationInformation,
    };
  });
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},

    componentBody: (
      <ImplementationStagesAdd
        shouldDisableFields={props.shouldDisableFields}
        implementationStagesId={implementationStagesId}
      />
    ),
    maxWidth: "500px",

    maxHeight: "800px",
    title: "مراحل التنفيذ",
  };

  useEffect(() => {
    dispatch(
      GetLengthImplementationStage({
        applicationInformationId:
          localStorage.getItem("ApplicationInformationId") ||
          props.applicationGuid,
      })
    );
  }, [stageLodingDelete, stageLodingAdd]);
  const RequestsColumns = [];

  const RequestAccessor = [
    {
      KeyName: "stages",
      ShowStatus: true,
      NmaeColumn: "المرحلة",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "stageName",
      ShowStatus: true,
      NmaeColumn: "اسم المرحلة",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      // comma: true,
    },
    {
      KeyName: "startingMonth",
      ShowStatus: true,
      NmaeColumn: "شهر البداية",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma: false,
    },
    {
      KeyName: "monthOfEnd",
      ShowStatus: true,
      NmaeColumn: "شهر النهاية",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma: false,
    },
    {
      KeyName: "implementationPeriodMonths",
      ShowStatus: true,
      NmaeColumn: "مدة التنفيذ بالأشهر",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma: false,
    },
  ];
  console.log(ImplementationStageLength, "ImplementationStageLength");

  useEffect(() => {
    dispatch(setRefreshTable());
  }, [stageLodingDelete, stageLodingAdd,EditImplementationStageLength]);

  const OtherMainBtns = [
    {
      Click: async (e) => {
        console.log(e.target.value,"sssssseeeeeeeeeesdwdwd");
        
        setImplementationStagesId(e.target.value)
        closePopupEditComponent()
      },
      content: "",
      className: "bi bi-pencil-square",
      id: "editBtn",
      title: "عرض",
      ShowStatus: !props.shouldDisableFields,
    },
    {
      Click: async (e) => {
        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then((res) => {
          if (res.isConfirmed == true) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "تم الحذف بنجاح",
              showConfirmButton: false,
              timer: 1500,
              // width: "500px",
            });
            //delete ow from table by id after confirmed
            console.log(e.tag, "malkkskskskjjsd");

            dispatch(
              DeleteImplementationStage({
                implementationStagesId: parseInt(e.target.value),
              })
            );
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "حذف",
      ShowStatus: !props.shouldDisableFields,
      ShowLast: true,
    },
  ];
    const closePopupEditComponent = () => {
    if (PopupComponentEditStatus) {
      setPopupComponentEditStatus(false);
    } else {
      setPopupComponentEditStatus(true);
    }
  };
  return true ? (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"implementationStagesId"}
        valueButtonAction={"implementationStagesId"}
        URL={`api/SU_NT_WPB_ImplementationStages/GetAllImplementationStage`}
        UrlBody={{
          applicationInformationId:
            localStorage.getItem("ApplicationInformationId") ||
            props.applicationGuid,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={""}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        lengthReportsStages={ImplementationStageLength}
        lastButton={true}
        //tableBtn={props.view ? false : true}
        tableBtn={!props.shouldDisableFields}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={OtherMainBtns}
        arrayButtonLastIndex={true}
        ArrayNameDataColum={RequestsColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        // popUpBody2={[<ShowApplication addFun={true} />]}
        // popUpId2={"ShowApplicationpopUp"}
        // popUpBody2={[
        //   <ShowApplication columnId={columnId} list={list} addFun={false} />,
        // ]}
        // handleCloseModal={handleCloseModal}
        // showModal={showPopUp}
      />
      <PopupAHSF
        title={"مراحل التنفيذ"}
        componentBody={
         <ImplementationStagesAdd
        shouldDisableFields={props.shouldDisableFields}
        implementationStagesId={implementationStagesId}
        EditOrView={true}

      />
        }
        maxWidth="500px"
        maxHeight="800px"
        isPopupOpenStatus={PopupComponentEditStatus}
        isPopupOpenFunction={closePopupEditComponent}
      />
    </>
  ) : (
    ""
  );
};

export default ImplementationStages;
